<script lang="ts">
  interface Zone {
    name: string;
    confidence: number;
    status: 'high' | 'medium' | 'low';
  }

  let {
    visible = false,
    category = '',
    confidence = 0,
    status = 'low' as 'high' | 'medium' | 'low',
    zones = [] as Zone[],
    compact = false
  }: {
    visible?: boolean;
    category?: string;
    confidence?: number;
    status?: 'high' | 'medium' | 'low';
    zones?: Zone[];
    compact?: boolean;
  } = $props();

  const isMulti = $derived(zones.length > 0);
  const displayZones = $derived(zones.slice(0, 3));
  const hasOverflow = $derived(zones.length > 3);
</script>

{#if visible}
  {#if isMulti}
    <div class="ar-data-tag ar-data-tag--multi" class:compact>
      <div class="ar-zones-list">
        {#each displayZones as zone}
          <div class="ar-zone-row">
            <span class="ar-zone-category">{zone.name}</span>
            <div class="ar-tag-confidence ar-tag-confidence--mini">
              <div class="ar-tag-bar">
                <div class="ar-tag-bar-fill {zone.status}" style="width: {zone.confidence * 100}%"></div>
              </div>
              <span class="ar-tag-percent">{(zone.confidence * 100).toFixed(0)}%</span>
            </div>
          </div>
        {/each}
        {#if hasOverflow}
          <div class="ar-zones-overflow">+{zones.length - 3}</div>
        {/if}
      </div>
    </div>
  {:else}
    <div class="ar-data-tag">
      <span class="ar-tag-category">{category}</span>
      <div class="ar-tag-confidence">
        <div class="ar-tag-bar">
          <div class="ar-tag-bar-fill {status}" style="width: {confidence * 100}%"></div>
        </div>
        <span class="ar-tag-percent">{(confidence * 100).toFixed(0)}%</span>
      </div>
    </div>
  {/if}
{/if}

<style>
  .ar-data-tag--multi {
    position: absolute;
    bottom: 80px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 20;
    background: rgba(10, 10, 20, 0.85);
    backdrop-filter: blur(8px);
    border: 1px solid rgba(96, 165, 250, 0.3);
    border-radius: 10px;
    padding: 8px 12px;
    min-width: 200px;
    max-width: 280px;
  }

  .ar-data-tag--multi.compact {
    bottom: 60px;
    min-width: 160px;
    padding: 6px 10px;
  }

  .ar-zones-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    max-height: 120px;
    overflow-y: auto;
  }

  .ar-zones-list::-webkit-scrollbar {
    width: 4px;
  }

  .ar-zones-list::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 2px;
  }

  .ar-zones-list::-webkit-scrollbar-thumb {
    background: rgba(96, 165, 250, 0.4);
    border-radius: 2px;
  }

  .ar-zone-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 4px 6px;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.04);
  }

  .ar-zone-category {
    font-size: 11px;
    font-weight: 600;
    color: #e0e7ff;
    letter-spacing: 0.3px;
    text-transform: uppercase;
  }

  .ar-tag-confidence--mini {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
  }

  .ar-tag-confidence--mini .ar-tag-bar {
    width: 50px;
    height: 4px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 2px;
    overflow: hidden;
  }

  .ar-tag-confidence--mini .ar-tag-bar-fill {
    height: 100%;
    border-radius: 2px;
    transition: width 0.3s ease;
  }

  .ar-tag-confidence--mini .ar-tag-percent {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.7);
    min-width: 28px;
    text-align: right;
  }

  .ar-tag-confidence--mini .ar-tag-bar-fill.high {
    background: #34d399;
  }

  .ar-tag-confidence--mini .ar-tag-bar-fill.medium {
    background: #fbbf24;
  }

  .ar-tag-confidence--mini .ar-tag-bar-fill.low {
    background: #f87171;
  }

  .ar-zones-overflow {
    font-size: 10px;
    color: rgba(96, 165, 250, 0.8);
    text-align: center;
    padding: 2px;
    letter-spacing: 0.5px;
  }
</style>